import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
import { ReactComponent as PolicyIcon } from '../../../assets/svg/action-dot-icon.svg'
import { Spinner } from '../../../helpers/commonUi/Spinner';
import { useToast } from "../../../helpers/commonFunction";
import { AddPolicyModal } from '../policy/AddPolicyModal'
import { logger } from '../../../constant/winston';
import React, { useCallback, useEffect, useState } from 'react'
import { Http } from "../../../helpers/axois";
import { useSelector } from 'react-redux'
import { useParams } from "react-router";
import NoData from '../../apps/NoData'
import style from './user.module.sass'
import { ReactComponent as CloseIcon } from '../../../assets/svg/team-close.svg'
import { Table } from 'antd'
// import {type} from 'os';
import { stringToHslColor } from '../../../helpers/util';
import { capitalize } from 'lodash';

const UserList: React.FC = () => {
    const [policyModalVisible, setPolicyModalVisible] = useState<any>(false);
    const [policyState, setPolicyState] = useState<boolean>(false);
    const [policyList, setPolicyList] = useState<any[]>([]);
    const [userClickedState, setUserClickedState] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any[]>([]);
    const [highlightSelectedUser, setHighlightSelectedUser] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [userData, setUserData] = useState<any>({});
    const [list, setList] = useState<any[]>([]);
    const params: any = useParams();
    const { ErrorToast } = useToast();
    const orgId = params["orgId"];

    const orgOwner = useSelector((state: any) => {
        return state.org.selectedOrg.owner
    });

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions));

    const canEditTeam = orgPermissions.includes('team.Edit');
    const canViewTeam = orgPermissions.includes('team.View');
    const canViewPolicy = orgPermissions.includes('policy.View');
    const canAttachPolicy = orgPermissions.includes('policy.Attach');
    const canRemovePolicy = orgPermissions.includes('policy.Remove');

    const CHOOSE_ADD_USER = 'Choose or add new user'

    // method for getting all policies available
    const getPolicy = useCallback(() => {
        Http.get(`/policy?orgId=${orgId}`).subscribe((res: any) => {
            setPolicyList(res);
        }, (err) => {
            ErrorToast('Error fetching policies');
        });
    }, [orgId, ErrorToast]);


    useEffect(() => {
        getPolicy();
    }, [getPolicy])

    useEffect(() => {
        setLoading(false);
        if (canViewTeam) {
            Http.get(`orgs/${orgId}/users`).subscribe((res: any) => {
                setList(res);
            }, (err) => {
                logger.error(err);
            });
            setPolicyState(false);
        };
    }, [orgId, canViewTeam, policyState]);

    if (loading) {
        return <Spinner />
    };


    const renderUsersOnTable = () => {
        let columns: any[] = [];
        !userClickedState ? columns = [
            {
                title: "User Name",
                dataIndex: "user_name",
                width: "25%"
            },
            {
                title: "Policy",
                dataIndex: "policies",
                width: "50%"
            },
            {
                title: "Teams",
                dataIndex: "teams",
                width: "25%"
            }
        ] : columns = [
            {
                title: "User Name",
                dataIndex: "user_name",
                width: "25%"
            },
            {
                title: "Policy",
                dataIndex: "policies",
                width: "50%"
            },
        ]

        const data: any[] = [];
        list && list.map((item: any, index: any) => {
            const isOwner = item.usr_id && item.usr_id === orgOwner
            return data.push(
                {
                    user_name: <div style={{ background: highlightSelectedUser?.usr_id === item.usr_id ? "#fbfbfb" : "" }}
                        key={item.usr_id} className={style.users_names}
                        onClick={() => { setUserClickedState(true); setHighlightSelectedUser(item); setSelectedUser([item]); }} >
                        <span data-test-id="users_username"
                            style={{
                                color: isOwner ? '#868686' : '#10002E',
                                fontWeight: 700,
                                fontSize: "14px"
                            }}>{`${item.user_name}${isOwner ? ' (Owner)' : ''}`}</span>
                        <span data-test-id="users_first_name"
                            style={{
                                color: isOwner ? '#868686' : '#787C8D',
                                fontWeight: 500,
                                fontSize: "12px"
                            }}>{item.first_name + " " + (item.last_name !== null ? item.last_name : "")}</span>
                    </div>,
                    teams: <div style={{ background: highlightSelectedUser?.usr_id === item.usr_id ? "#fbfbfb" : "" }}
                        className={style.teams} onClick={() => { setUserClickedState(true); setHighlightSelectedUser(item); setSelectedUser([item]) }}>
                        <div key={index} style={{ display: "flex" }}>
                            {item.teams && item.teams.map((team: any, i: any) => {
                                if (i <= 3) {
                                    let word = team.team_name && team.team_name[0];
                                    return <div key={i} className={style.round_icon}>
                                        <div
                                            className={style.team_word}
                                            style={{
                                                backgroundColor: stringToHslColor(team.team_name, 70, 50, 15),
                                                color: stringToHslColor(team.team_name, 70, 45),
                                            }}> {capitalize(word)} </div>
                                    </div>
                                } else {
                                    return i === 4 && <div key={i} className={style.round_icon}>
                                        <div
                                            className={style.team_word}
                                            style={{
                                                backgroundColor: "rgba(215, 217, 229, 0.43)",
                                                color: "#787C8D",
                                            }}> {"+" + (item.teams.length - 4)} </div>
                                    </div>
                                }
                            })}
                        </div>
                        <div className={style.edit_section} >
                            {item.usr_id !== orgOwner && <div>
                                <div
                                    data-test-id="users_action"
                                    onClick={(e: any) => {
                                        e.stopPropagation();
                                        if (canEditTeam && canViewPolicy && (canRemovePolicy || canAttachPolicy)) {
                                            setUserData({
                                                ...item,
                                                canAttach: canAttachPolicy,
                                                canRemove: canRemovePolicy
                                            });
                                            setPolicyModalVisible(true);
                                        } else {
                                            ErrorToast('You are not authorized to update policies of an user');
                                        }
                                    }}
                                    className={style.edit_icon}
                                >
                                    <PolicyIcon height="20px" />
                                </div>
                            </div>}

                        </div>
                    </div>,
                    policies: <div style={{ background: highlightSelectedUser?.usr_id === item.usr_id ? "#fbfbfb" : "" }}
                        key={index} onClick={() => { setUserClickedState(true); setHighlightSelectedUser(item); setSelectedUser([item]) }} >
                        <div className={style.policies}>
                            {
                                item.user_policies && item.user_policies.map((tp: any, i: any) => {
                                    const policyInfo = policyList.find((pl: any) => pl.id_ === tp);
                                    return <div key={i} className={style.aligning}>
                                        {(tp && policyInfo) && <div className={style.box}>
                                            <div className={style.fontStyle}>{policyInfo && policyInfo.name}</div>
                                        </div>}
                                    </div>
                                })
                            }
                        </div>

                    </div>,
                }
            )
        })

        return (
            <div>
                <Table
                    // rowSelection={rowSelection}
                    data-test-id="users_table"
                    pagination={false}
                    // rowSelection={{ 
                    // type : 'checkbox',
                    // onChange: (selectedRowKeys, selectedRows) => {
                    // }
                    // }}
                    scroll={{ y: 'calc(100vh - 240px)' }}
                    columns={columns}
                    // onRow={(record: any, rowIndex: any) => {
                    //   return {
                    //     onClick: (event: any) => {
                    //       let target: any = event.target;
                    //       if (target.tagName !== "A") {
                    //         this.props.updateSelectedApp({
                    //           id: record.appId,
                    //           name: record.name
                    //         })
                    //         this.props.history.push("/apps/list/" + record.appId + "/forms/list");
                    //       }
                    //     }
                    //   };
                    // }}
                    className='override-table-container cus_user'
                    dataSource={data}
                >
                </Table>
            </div>
        )
    }


    return (
        <>
            <div style={{ paddingRight: userClickedState ? "0px" : "15px" }}>

                <div style={{ display: "flex", alignItems:"center", justifyContent:"center"}}>
                    {canViewTeam ?
                        <div className={style.userListContainer} style={{ paddingRight: userClickedState ? "0px" : "15px" }} >
                            <div className={style.title} style={{ display: "flex" }}>
                                <div className={style.titleContent}>
                                    <h3>Users</h3>
                                    <p>{CHOOSE_ADD_USER}</p>
                                </div>
                                {/* reserved for future use */}
                                {/* this is for add and delete user  <div style={{width: "50%", display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                    <div style={{display: "flex", alignItems: "center", width: "85px"}}>
                                        <Delete height={20} width={20} style={{marginRight: "10px"}} />
                                        <div style={{color: "#CCD0DD", width: "70px", height: "18px", fontStyle: "normal", fontWeight: 400, fontSize: "14px", }}>DELETE</div>
                                    </div>
                                    <div>
                                        <Divider type='vertical' style={{height: "30px", marginRight: "40px"}} />
                                    </div>
                                    <div style={{}} className={Style.add} >
                                        <Button style={{width: "135px", height: "36px"}} type="primary">ADD</Button>
                                    </div>
                                </div> */}
                            </div>
                            <div>
                                {renderUsersOnTable()}
                            </div>
                        </div>
                        :
                        <NoData
                            svg={WarningIcon}
                            header='Not Authorized'
                            content='Please request owner of this organization to provide access'
                            noButton={true}
                        />}
                    <div style={{ height: window.innerHeight - 100, transition: 'width 0.5s', width: userClickedState ? "480px" : "0px", zIndex: 9999 }}>
                        {userClickedState && <div className={style.user_sidePanel}
                            style={{ height: window.innerHeight - 100, }}>
                            {selectedUser && selectedUser.map((user: any) => {
                                return <div>
                                    <div className={style.title}>
                                        <div className={style.name_font}>{user.user_name}</div>
                                        <div className={style.close_icon} onClick={() => { setUserClickedState(false); setHighlightSelectedUser(null) }}><CloseIcon /></div>
                                    </div>
                                    <div className={style.user_details}>
                                        User Details
                                    </div>
                                    <div className={style.details_board}>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <div className={style.firstName_userName_sec}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div className={style.label}>First Name:</div>
                                                    <div className={style.data}>{user.first_name}</div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", marginRight: "10px" }}>
                                                    <div className={style.label} >User Name:</div>
                                                    <div className={style.data}>{user.user_name}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div className={style.label}>Email:</div>
                                                    <div className={style.data}>{user.email}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={style.team_title}>Teams</div>
                                        <div className={style.team_list} style={{ overflowY: "auto", height: window.innerHeight - 450, padding: "3px" }}>
                                            {user.teams && user.teams.map((teams: any) => {
                                                let word = teams && teams.team_name[0]
                                                return <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <div className={style.team_name}
                                                            style={{
                                                                backgroundColor: stringToHslColor(teams.team_name, 70, 50, 15),
                                                                color: stringToHslColor(teams.team_name, 70, 45),
                                                            }}>{capitalize(word)}</div>
                                                        <div>{teams.team_name}</div>
                                                    </div>
                                                    <div className={style.bottom_line}></div>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            })
                            }
                        </div>}
                    </div>
                </div>
            </div>
            {
                policyModalVisible &&
                <AddPolicyModal
                    from='user'
                    data={userData}
                    setPolicyState={setPolicyState}
                    policyModalVisible={policyModalVisible}
                    setPolicyModalVisible={setPolicyModalVisible}
                    orgId={orgId}
                />
            }
        </>

    )

}

export default UserList
